import storage from '@/storage'
export default ({ to, next, store }) => {
    try {
       
        // Verificar se é login via SSO
        const isSSOLogin = localStorage.getItem('universe-sso-flag') === 'true';
        
        // Verificar dados do usuário
        const userData = localStorage.getItem('universe-user');
        
        if (isSSOLogin) {
            // Login SSO, verificar se temos dados do usuário
            // O token está em cookie HttpOnly e não acessível via JS
            if (userData) {
                return next(); // Permitir acesso - usuário SSO autenticado
            } else {
                // Verificar se já estamos na página de logout para evitar loop
                if (to.name === 'logout') {
                    return next();
                } else {
                    return next({ name: 'logout' });
                }
            }
        } else {
            // Login tradicional - verificar token no sessionStorage
            const token = storage.getUniverseToken();
            
            if (!token) {
                return next({ name: 'login' });
            } else {
                return next();
            }
        }
    } catch (error) {
        return next({ name: 'login' });
    }
}